import { Link, Route, Routes, useLocation } from 'react-router-dom'

import { HomePage } from './pages/HomePage'
import { PostPage } from './pages/PostPage'
import { posts } from './posts'

export const BlogApp = () => {
  const { pathname } = useLocation()

  return (
    <div className="blog">
      <a className="blog__skip" href="#main">
        Skip to content
      </a>

      <header className="topbar">
        <div className="topbar__inner">
          <a className="topbar__brand" href="https://revel.club">
            <span className="topbar__mark" aria-hidden="true" />
            <span className="topbar__name">Revel Club</span>
          </a>
          <nav className="topbar__nav" aria-label="Primary">
            <a href="https://revel.club">Club</a>
            <Link to="/" aria-current={pathname === '/' ? 'page' : undefined}>
              Blog
            </Link>
            <a href="https://app.revel.club/login">Sign in</a>
            <a className="topbar__cta" href="https://app.revel.club/register">
              Apply
            </a>
          </nav>
        </div>
      </header>

      <main id="main" className="blog__main">
        <Routes>
          <Route path="/" element={<HomePage posts={posts} />} />
          <Route path="/posts/:slug" element={<PostPage posts={posts} />} />
        </Routes>
      </main>

      <footer className="foot">
        <div className="foot__inner">
          <p className="foot__copy">© {new Date().getFullYear()} Revel Club</p>
          <div className="foot__links">
            <a href="https://revel.club">Club</a>
            <Link to="/">Blog</Link>
            <a href="https://app.revel.club/register">Apply</a>
            <a href="https://app.revel.club/login">Sign in</a>
          </div>
        </div>
      </footer>
    </div>
  )
}
